<app-crud-edit
  [sectionTitle]="sectionTitle"
  [buttonTitle]="buttonTitle"
  [entityroot]="entityrooturl"
  [onSubmit]="onSubmitHandler()"
  [onCancel]="onCancelHandler()"
  [form]="form"
  [fields]="fields"
  [options]="options"
  [model]="model"
  [isReady]="isReady"
  [isSubmitting]="isSubmitting"
></app-crud-edit>
